/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ReferralList } from '../models/ReferralList';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class ReferralsService {
    /**
     * List Referrals
     * @param cursor
     * @returns ReferralList Successful Response
     * @throws ApiError
     */
    public static listReferralsApiReferralsGet(
        cursor?: (string | null),
    ): CancelablePromise<ReferralList> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/referrals/',
            query: {
                'cursor': cursor,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Remaining Female Spots
     * @returns number Successful Response
     * @throws ApiError
     */
    public static remainingFemaleSpotsApiReferralsFemaleSpotsGet(): CancelablePromise<number> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/referrals/female-spots',
        });
    }
}
